import { render, staticRenderFns } from "./GestaoArquivos.vue?vue&type=template&id=076ebbd2&scoped=true"
import script from "./GestaoArquivos.vue?vue&type=script&lang=js"
export * from "./GestaoArquivos.vue?vue&type=script&lang=js"
import style0 from "./GestaoArquivos.vue?vue&type=style&index=0&id=076ebbd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076ebbd2",
  null
  
)

export default component.exports